import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LegalIcon } from '../../assets/img/legal.svg';
import { ReactComponent as ImageIcon } from '../../assets/img/image.svg';
import { ReactComponent as ShoppingIcon } from '../../assets/img/shopping.svg';
import { ReactComponent as ArticleIcon } from '../../assets/img/article.svg';
import { useTranslation } from 'react-i18next';

function HomeScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const modules = [
        { id: 1, title: 'home.product.title', subtitle: 'home.product.subtitle', path: '/product', icon: ShoppingIcon },
        { id: 2, title: 'home.article.title', subtitle: 'home.article.subtitle', path: '/article', icon: ArticleIcon }
    ];

    const modules2 = [
        { id: 3, title: 'home.image.title', subtitle: 'home.image.subtitle', path: '/image', icon: ImageIcon },
        { id: 4, title: 'home.legal.title', subtitle: 'home.legal.subtitle', path: '/terms', icon: LegalIcon }
    ];

    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col xs={12} className="text-center">
                    <h2 className="title">{t('home.title')}</h2>
                </Col>
            </Row>

            <Row className="mb-4 g-4 justify-content-center">
                {modules.map((module) => {
                    const IconComponent = module.icon;
                    return (
                        <Col key={module.id} xs={12} md={6} className="card-custom-container">
                            <div
                                className="card-custom-content d-flex align-items-center justify-content-center flex-column text-center"
                                onClick={() => navigate(module.path)}
                                role="button"
                                style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                            >
                                <IconComponent className="mb-3 card-svg" />
                                <h3 className="card-title text-capitalize mb-1">
                                    {t(module.title)}
                                </h3>
                                <p className="card-subtitle mb-0">{t(module.subtitle)}</p>
                            </div>
                        </Col>
                    );
                })}
            </Row>

            <Row className="mb-4 g-4 justify-content-center">
                {modules2.map((module) => {
                    const IconComponent = module.icon;
                    return (
                        <Col key={module.id} xs={12} md={6} className="card-custom-container">
                            <div
                                className="card-custom-content d-flex align-items-center justify-content-center flex-column text-center"
                                onClick={() => navigate(module.path)}
                                role="button"
                                style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                            >
                                <IconComponent className="mb-3 card-svg" />
                                <h3 className="card-title text-capitalize mb-1">
                                    {t(module.title)}
                                </h3>
                                <p className="card-subtitle mb-0">{t(module.subtitle)}</p>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
}

export default HomeScreen;
